import React from "react"
import { Button, Grid } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"
import { UILanguageSelectorBox } from "./Box"
import uniqueId from "utils/uniqueId"
import { styles } from "./LanguageSelector.styles"

export const LanguageSelectorUI = ({
  currentLanguageName,
  languages,
  open,
  anchorEl,
  onOpen,
  onClose,
  onSelectLanguage,
}) => {
  const buttonId = uniqueId("languageSelector-")
  const menuId = uniqueId("languageSelectorMenu-")

  return (
    <Grid sx={styles.languageSelector}>
      <Button
        variant="outlined"
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={onOpen}
        sx={styles.languageSelectorButton}
      >
        {currentLanguageName}
        <FontAwesomeIcon icon={faCaretDown} />
      </Button>

      <UILanguageSelectorBox
        languageList={languages}
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        onSelectLanguage={onSelectLanguage}
        MenuListProps={{
          "aria-labelledby": buttonId,
        }}
      />
    </Grid>
  )
}

export default LanguageSelectorUI
